// extracted by mini-css-extract-plugin
export default {"accountAssetsContainer":"AccountAssets_accountAssetsContainer__QhLlv","header":"AccountAssets_header__P9Ij-"};